import type { GenericSelectItem } from "@/common/types/types";
import { Combobox } from "@/components/ui/Combobox";
import Country from "country-state-city/lib/country";
import type { ICountry } from "country-state-city/lib/interface";

interface Props {
  placeholder?: string;
  onValueChange: ({ value, label }: GenericSelectItem) => void;
  value?: string;
}

const countries = Country.getAllCountries().map((country: ICountry) => ({
  value: country.isoCode,
  label: country.name,
}));

export const CountryCombobox = (props: Props): JSX.Element => {
  return (
    <Combobox
      items={countries}
      value={props.value}
      onValueChange={(value) => {
        props.onValueChange({ label: value.label, value: value.value });
      }}
    />
  );
};
